export default function Logo({ className = "h-10 w-10" }) {
  return (
    <img
      src="/logo.png"
      alt="Ristorante Milano"
      className={`${className} rounded-full object-cover`}
    />
  );
}
